var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBBrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 372,
    viewBox: "0 0 320 372",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.535 159.319L310.61 155.425L319.415 170.676L278.364 168.715C278.356 165.587 278.089 162.44 277.535 159.319ZM298.237 133.996L291.169 121.754L268.385 137.417C269.327 138.758 270.225 140.139 271.059 141.583C271.84 142.936 272.542 144.316 273.199 145.708L298.237 133.996ZM258.933 127.101L278.842 100.404L270.037 85.1526L251.21 121.684C253.915 123.255 256.507 125.06 258.933 127.101Z",
    fill: "#FFF44F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.292 371C57.1011 371 1 314.899 1 245.841V153.274H251.451V245.708C251.585 314.899 195.484 371 126.292 371Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.375 245.001C144.151 241.418 150.335 232.798 150.335 222.733C150.335 209.454 139.571 198.689 126.292 198.689C113.013 198.689 102.249 209.454 102.249 222.733C102.249 232.848 108.496 241.505 117.342 245.055V285.513H135.375V245.001Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5051 153.274V72.5957C59.5051 51.491 76.6025 34.3935 97.7072 34.3935H154.877C175.982 34.3935 193.079 51.491 193.079 72.5957V113.202H226.473V72.5957C226.473 33.0578 194.415 1 154.877 1H97.7072C58.1693 1 26.1116 33.0578 26.1116 72.5957V153.274",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBBrand);
export default __webpack_public_path__ + "static/media/b_brand.246f6100199fae8e65481e18a408946a.svg";
export { ForwardRef as ReactComponent };